(function() { window.GUID_4f6395b6_bd71_49da_8695_06f1e04eb3d9 = { getGuid: function() { return "4f6395b6-bd71-49da-8695-06f1e04eb3d9"; } }; })();
function OnScoreSheetItemClicked(element, container) {
    ClearIsHighlighted();
    var t = element.data("t"); //TeamNumber
    var p = element.data("p"); //PlayerNumber
    var g = element.data("g"); //GameNumber
    var r = element.data("r"); //GameRound
    var so = element.data("so"); //GameRound
    var gs = [];
    var ps = [];
    var rs = [];
    var sos = [];
    if (t === "") {
        t = null;
    }
    if (p === "") {
        p = null;
    }
    if (g === "") {
        g = null;
    }
    if (r === "") {
        r = null;
    }
    if (so === "") {
        so = null;
    }
    var highlightAllGames = false;
    if (g != null) {
        if (g.toString().indexOf(",") > -1) {
            gs = g.split(",");
        }
        else {
            gs.push(g);
        }
    }
    if (p != null) {
        if (p.toString().indexOf(",") > -1) {
            ps = p.split(",");
        }
        else {
            ps.push(p);
        }
    }
    if (r != null) {
        if (r.toString().indexOf(",") > -1) {
            rs = r.split(",");
        }
        else {
            rs.push(r);
        }
    }
    if (so != null) {
        if (so.toString().indexOf(",") > -1) {
            sos = so.split(",");
        }
        else {
            sos.push(r);
        }
    }
    if (element.hasClass("VTTeam") && t != null) {
        var players = $(".VTPlayer[data-t=" + t + "]", container);
        var scores = $(".VTScore[data-t=" + t + "]", container);
        players.addClass("IsHighlighted");
        scores.addClass("IsHighlighted");
    }
    else if (element.hasClass("VTPlayer")) {
        highlightAllGames = true;
    }
    else if (element.hasClass("VTScore")) {
        highlightAllGames = false;
    }
    if (t != null && !element.hasClass("VTTeam")) {
        var team = $(".VTTeam[data-t=" + t + "]", container);
        team.addClass("IsHighlighted");
    }
    if (gs != null) {
        $.each(gs, function (i, ga) {
            var game = $('.VTScore[data-g="' + ga + '"][data-t=' + t + "]", container);
            game.addClass("IsHighlighted");
            var oppGame = $('.VTScore[data-g="' + ga + '"][data-t!=' + t + "]", container);
            oppGame.addClass("IsHighlightedOpp");
        });
    }
    if (ps != null) {
        $.each(ps, function (i, p) {
            var player = $('.VTPlayer[data-p="' + p + '"][data-t=' + t + "]", container);
            player.addClass("IsHighlighted");
            if (highlightAllGames) {
                var games = $('.VTScore[data-p="' + p + '"][data-t=' + t + "]", container);
                games.addClass("IsHighlighted");
                $.each(games, function (y, game) {
                    var g = $(game).data("g");
                    var oppGame = $('.VTScore[data-g="' + g + '"][data-t!=' + t + "]", container);
                    oppGame.addClass("IsHighlightedOpp");
                });
            }
        });
    }
    if (rs != null) {
        $.each(rs, function (i, r) {
            var game = $('.VTScore[data-r="' + r + '"][data-t=' + t + "]", container);
            game.addClass("IsHighlighted");
        });
    }
    if (sos != null) {
        $.each(sos, function (i, so) {
            var element = $("#E" + so, container);
            element.addClass("IsHighlighted");
        });
    }
    element.addClass("IsHighlightedSelf");
}
function ClearIsHighlighted() {
    $(".IsHighlightedSelf").removeClass("IsHighlightedSelf");
    $(".IsHighlighted").removeClass("IsHighlighted");
    $(".IsHighlightedOpp").removeClass("IsHighlightedOpp");
}

//# sourceMappingURL=ScoreSheet.js.map
